export default import.meta.ROLLDOWN_FILE_URL_NsvdQahKm8oHzTA0Co75eA